import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VerificationComponent } from './modules/verification/verification.component';
import { DashboardComponent } from './modules/dashboard/dashboard.component';
import { AdminComponent } from './modules/admin/admin.component';
import { ClientsComponent } from './modules/clients/clients.component';
import { UserComponent } from './modules/user/user.component';
import { AdminUsergroupComponent } from './modules/admin-usergroup/admin-usergroup.component';
import { MKSComponent } from './modules/admin-mks/admin-mks.component';
import { AdminGksComponent } from './modules/admin-gks/admin-gks.component';
import { AdminAccessComponent } from './modules/admin/admin-access/admin-access.component';

const routes: Routes = [
    { path: 'verify', component: VerificationComponent },
    { path: '', component: DashboardComponent },
    { path: 'admin', redirectTo: '/client', pathMatch: 'full' },
    {
        path: 'admin',
        component: AdminComponent,
        children: [
            {
                path: 'client',
                component: ClientsComponent, // Client component as a child route
            },
            {
                path: 'user',
                component: UserComponent,
            },
            {
                path: 'user-group',
                component: AdminUsergroupComponent,
            },
            {
                path: 'my-content',
                component: MKSComponent, // MKS component as a child route
            },
            {
                path: 'knowledge-store',
                component: AdminGksComponent,
            },
            {
                path: 'access',
                component: AdminAccessComponent,
            },
            // Other child routes can go here
        ],
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
